module.exports = __webpack_public_path__ + "fonts/Sarabun-LightItalic.0a83e367.ttf";